module.exports = __webpack_public_path__ + "static/CleverExperience-7e4606003427a1b9bbee02be17122635.png";